webpackJsonp([76],{

/***/ 1331:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1332);


/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(170);

var _datetime2 = _interopRequireDefault(_datetime);

var _fr = __webpack_require__(773);

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('fr', _fr2.default);

/***/ })

},[1331]);


// WEBPACK FOOTER //
// app/datetime.fr-16e4cd329c03d525581b.js